exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.content[data-v-58dd5e27] {\n  width: 1200px;\n  margin: 0 auto;\n  border: 1px solid transparent;\n}\n", "", {"version":3,"sources":["E:/好汉/检索系统/新git地址/gx_frontend/src/view/messageDetail.vue"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,eAAe;EACf,8BAA8B;CAC/B","file":"messageDetail.vue","sourcesContent":["\n.content[data-v-58dd5e27] {\n  width: 1200px;\n  margin: 0 auto;\n  border: 1px solid transparent;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58dd5e27","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/messageDetail.vue
// module id = 8Ie/
// module chunks = 2